// extracted by mini-css-extract-plugin
module.exports = {"scroll-tabs":"scroll-tab_scroll-tabs__IT_b8","scroll-tab":"scroll-tab_scroll-tab__2Z4no","scroll-tab--active":"scroll-tab_scroll-tab--active__1du05"};